<template>
  <div class="content">
    <div class="line_bottom"  v-for="(item, index) in caseList" :key="index">
      <div class="edge">
        <div class="pic"  @click="checkFile(item.filePath, item.fileName)">
          <img v-if="item.fileType == 'pdf'   || item.fileType == 'application/pdf'" src="../../../../assets/appraise/ic_pdf.png" />
          <img v-if="item.fileType == 'doc'  || item.fileType == 'application/doc'  " src="../../../../assets/appraise/ic_doc.png" />
          <img v-if="item.fileType == 'exl'  || item.fileType == 'application/exl' " src="../../../../assets/appraise/ic_exl.png" />
        </div>
        <div class="text"  @click="checkFile(item.filePath, item.fileName)">{{ item.fileName }}.{{ item.fileType }}</div>
        <img class="imgdiv" @click="deleteFile(item)" src="../../../../assets/appraise/delete.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "materialScience_line",
  props: {
    caseList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    deleteFile(item){
      // filePath
      this.$emit('deleteFiel', item);
   
    //  this.caseList = newdata;
    },
    checkFile(url, name) {
    //  const str = navigator.userAgent.toLowerCase();
    //   const ver = str.match(/cpu iphone os (.*?) like mac os/);
    //   if (!ver) {
    //     console.log("---安卓进来这里url:", url);
    //     // this.$toast('当前暂不支持预览附件')
    //     // console.log('不是苹果')
    //     this.$router.push({ path: "/appraise/iframepdf", query: { url: url } });
    //   } else {
    //     window.yyn.invokeJSB(
    //       "openWindow",
    //       {
    //         openUrl: url,
    //         isFullScreen: 0,
    //         setTitle: name,
    //         needLoading: 1,
    //       },
    //       (cb) => {
    //         console.log(cb, "callback");
    //       }
    //     );
    //   }
    }
  }
};
</script>
<style lang="less" scoped>
.content{
    padding: 0 12px;
}
.edge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    flex: 1;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    padding-right: 32px;
    margin-left: 12px;
  }
  .pic {
    width: 34px;
    height: 38px;
  }
  .imgdiv {
    width: 15px;
    height: 16px;
  }
}
.line_bottom:last-child::after{
    background: none;
}

.line_bottom{
    padding: 16px 0 16px 0;
}
</style>
